import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedProfileId, setSelectedProfileId } from "../../slices/bp";
export const useSelectedProfileId = () => {
    const dispatch = useDispatch();
    const selectedProfileId = useSelector(getSelectedProfileId);
    const update = useCallback((value) => {
        dispatch(setSelectedProfileId(value));
    }, [dispatch]);
    return [selectedProfileId, update];
};
